var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    fill: "white",
    stroke: "#1E334E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 4.5C10.548 4.5 4.5 10.548 4.5 18C4.5 25.452 10.548 31.5 18 31.5C25.452 31.5 31.5 25.452 31.5 18C31.5 10.548 25.452 4.5 18 4.5ZM18 8.55C20.241 8.55 22.05 10.359 22.05 12.6C22.05 14.841 20.241 16.65 18 16.65C15.759 16.65 13.95 14.841 13.95 12.6C13.95 10.359 15.759 8.55 18 8.55ZM18 27.72C14.625 27.72 11.6415 25.992 9.9 23.373C9.9405 20.6865 15.3 19.215 18 19.215C20.6865 19.215 26.0595 20.6865 26.1 23.373C24.3585 25.992 21.375 27.72 18 27.72Z",
    fill: "#1E334E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(4.5 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.1e4a294cf78b0b0df0b1becc401290e1.svg";
export { ForwardRef as ReactComponent };